import { Col, Form, Row } from "react-bootstrap";

export const InputSpan = ({
  label,
  value,
  className = "",
  size = 6,
  readOnly = true,
}: {
  label: string;
  value: string | number;
  className?: string;
  size?: number;
  readOnly?: boolean;
}) => (
  <Col md={size}>
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <Form.Control readOnly={readOnly} value={value} />
    </Form.Group>
  </Col>
);
